import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import { cityNameValidation, postalCodeValidation, streetNameValidation } from 'validators';
import { Grid, GridItem, MenuItem, Select, TextField } from 'seagull';
import { AddressAutocomplete } from '~/components/AddressAutocomplete';
import { states as statesList } from '~/constants';
import { connectControllerToAutocomplete, connectControllerToTextField } from '~/utils/react-hook-form.utils';
export default function PostalAddressForm(props) {
    const { testId = 'postal-address-form' } = props;
    const { control, setValue } = useFormContext();
    const addressOneValidator = streetNameValidation(undefined, {
        required: true
    });
    const addressTwoValidator = streetNameValidation();
    const cityValidator = cityNameValidation(undefined, {
        required: true
    });
    const stateValidator = {
        required: true
    };
    const postalCodeValidator = postalCodeValidation(undefined, {
        required: true
    });
    return /*#__PURE__*/ _jsxs(Grid, {
        rowGap: "small",
        testId: "".concat(testId),
        children: [
            /*#__PURE__*/ _jsx(GridItem, {
                span: 12,
                children: /*#__PURE__*/ _jsx(Controller, {
                    control: control,
                    name: "postalAddress.address1",
                    rules: addressOneValidator,
                    render: (renderProps)=>{
                        return /*#__PURE__*/ _jsx(AddressAutocomplete, _object_spread_props(_object_spread({
                            testId: "".concat(testId, "-address-1")
                        }, connectControllerToAutocomplete(renderProps, {
                            label: 'Address 1',
                            placeholder: 'Enter an address'
                        })), {
                            onSelectPlace: (place)=>{
                                if (!place || !place.formatted) return;
                                const { address1, address2, city, state, postalCode } = place.formatted;
                                const options = {
                                    shouldValidate: true,
                                    shouldDirty: true,
                                    shouldTouch: true
                                };
                                setValue('postalAddress.address1', address1, options);
                                setValue('postalAddress.address2', address2, options);
                                setValue('postalAddress.city', city, options);
                                setValue('postalAddress.state', state, options);
                                setValue('postalAddress.postalCode', postalCode, options);
                            }
                        }));
                    }
                })
            }),
            /*#__PURE__*/ _jsx(GridItem, {
                span: 12,
                children: /*#__PURE__*/ _jsx(Controller, {
                    control: control,
                    name: "postalAddress.address2",
                    rules: addressTwoValidator,
                    render: (renderProps)=>/*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({
                            collapseHelperText: false
                        }, connectControllerToTextField(renderProps)), {
                            testId: "".concat(testId, "-address-2"),
                            label: "Address 2 (optional)"
                        }))
                })
            }),
            /*#__PURE__*/ _jsx(GridItem, {
                span: 5,
                children: /*#__PURE__*/ _jsx(Controller, {
                    control: control,
                    name: "postalAddress.city",
                    rules: cityValidator,
                    render: (renderProps)=>/*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({
                            collapseHelperText: false
                        }, connectControllerToTextField(renderProps)), {
                            testId: "".concat(testId, "-city"),
                            label: "City"
                        }))
                })
            }),
            /*#__PURE__*/ _jsx(GridItem, {
                span: 3,
                children: /*#__PURE__*/ _jsx(Controller, {
                    control: control,
                    name: "postalAddress.state",
                    rules: stateValidator,
                    render: (renderProps)=>/*#__PURE__*/ _jsx(Select, _object_spread_props(_object_spread({
                            collapseHelperText: false
                        }, connectControllerToTextField(renderProps)), {
                            label: "State",
                            testId: "".concat(testId, "-state"),
                            children: statesList.map((state)=>/*#__PURE__*/ _jsx(MenuItem, {
                                    value: state,
                                    testId: "".concat(testId, "-state-option-").concat(state),
                                    children: state
                                }, state))
                        }))
                })
            }),
            /*#__PURE__*/ _jsx(GridItem, {
                span: 4,
                children: /*#__PURE__*/ _jsx(Controller, {
                    control: control,
                    name: "postalAddress.postalCode",
                    rules: postalCodeValidator,
                    render: (renderProps)=>/*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({
                            collapseHelperText: false
                        }, connectControllerToTextField(renderProps)), {
                            testId: "".concat(testId, "-postal-code"),
                            label: "ZIP Code"
                        }))
                })
            })
        ]
    });
}
